export default "__VITE_ASSET__3a8ee2be__"